import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  public trueOrder: any = {
    DrugSearchBoxTable:'["drugGenricName","drugBrandName","drugBrandPersianName","companyName","drugPackageCount","country","buyPrice","sellPrice"]',
    'columnsArray_/TechnicalRight':
      '["name","amount","startTime","endTime","isOTC","isHoliday"]',
    'columnsArray_/Essentials':
      '["name","persianName","countryName","cost","buyPrice","drugFormName","drugUsageName","drugPackageCount","creatorCompanyName","erxCode","irc","gtn","attachment","flavor","keepingTypeName","licenseCompanyName","productTypeName","drugGenericName"]',
    'columnsArray_/DrugDistributor':
      '["name","nationalCode","phoneNumber","fax","address"]',
    'columnsArray_/Check':
      '["bankName","accountNumber","checkBookName","checkNumber","cost","checkDate","reason","reciver","nationalCode","comment","isPassed"]',
    'columnsArray_/fastSale':
      '["saleFactorType","dateAdded","factorNumber","barcode","totalPrice"]',
    'columnsArray_/Seller':
      '["firstName","lastName","phoneNumber","mobileNumber","drugDistributorsName"]',
    'columnsArray_/KeepingType':
      '["name","persianName","description"]',
    'columnsArray_/User':
      '["firstName","lastName","phoneNumber","nationalCode","mobilePhone","insuranceNumber","positionName","roleName","birthday","username","imageurl"]',
    'columnsArray_/Buy':
      '["companyName","factorNumber","factorDelivery","factorDate","discount","totalPrice","paidState","haveBuyReturn","description"]',
    'columnsArray_/Supplement':
      '["name","persianName","countryName","drugFormName","drugUsageName","buyPrice","cost","drugPackageCount","erxCode","irc","gtn","licenseCompanyName","attachment","flavor","drugGenericName","creatorCompanyName","keepingTypeName","productTypeName"]',
    'columnsArray_/NaturalRemedy':
      '["name","persianName","countryName","drugFormName","drugUsageName","buyPrice","cost","drugPackageCount","erxCode","irc","gtn","licenseCompanyName","attachment","flavor","drugGenericName","creatorCompanyName","keepingTypeName","productTypeName"]',
    'columnsArray_/TraditionalDrug':
      '["name","persianName","countryName","drugFormName","drugUsageName","keepingTypeName","cost","buyPrice","erxCode","irc","gtn","drugPackageCount","attachment","flavor","drugGenericName","creatorCompanyName","licenseCompanyName","productTypeName"]',
    'columnsArray_/Drug':
      '["drugGenericName","name","persianName","countryName","buyPrice","cost","drugFormName","drugUsageName","erxCode","irc","gtn","attachment","flavor","creatorCompanyName","drugPackageCount","keepingTypeName","licenseCompanyName","productTypeName"]',
    'columnsArray_/Company':
      '["name","persianName","countryName","phoneNumber","fax","address"]',
    'columnsArray_/MilkPowder':
      '["name","persianName","countryName","drugFormName","drugUsageName","buyPrice","cost","drugPackageCount","keepingTypeName","erxCode","irc","gtn","attachment","flavor","drugGenericName","creatorCompanyName","licenseCompanyName","productTypeName"]',
    'columnsArray_/BankAccount':
      '["firstName","lastName","bankName","accountNumber","cardNumber","comment"]',
    'columnsArray_/CheckBook':
      '["name","bankName","accountOwnerName","accountNumber","recivedDate","checkBookTypeName","checkBookCountName"]',
    DrugSaleSearchBoxTable:
      '["drugGenricCode","drugGenricName","drugBrandName","drugBrandPersianName","country","sellPrice","stockName","drugPackage","count","expierDate","keepingType","erxCode","minimumCount","minimumDigitalCount","drugPackageCount","lot","companyName","buyPrice","selected"]',
    'columnsArray_/Doctor':
      '["firstName","lastName","medicalCouncilCode","telephoneNumber","doctorSpecialtyName","address"]',
    'columnsArray_/Patient':
      '["firstName","lastName","fatherName","melliCode","certificateCode","birthDate","gender","isMarried","insuranceCode","telephoneNumber","mobileNumber","agentTelephoneNumber","address","email","doctorName","doctorTelephoneNumber","doctorAddress","weight","height","sensitivityHistory","illnessHistory","drugHistory","job","isSmoker","isTea","diet","sport","comment"]',
    'columnsArray_/Sale':
      '["saleFactorType","dateAdded","factorNumber","barcode","totalPrice"]',
  };

  public logAllLocalStorage() {
    const localStorageContent: any = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        localStorageContent[key] = localStorage.getItem(key);
      }
    }
    console.log(localStorageContent);
  }

  public initializeDefaultKeys() {
    for (const key in this.trueOrder) {
      if (this.trueOrder.hasOwnProperty(key)) {
        if (!localStorage.getItem(key)) {
          localStorage.setItem(key, this.trueOrder[key]);
        }
      }
    }
  }

}
